export default "__VITE_ASSET__BvgaahmE__"